export default __webpack_public_path__ + "static/service-inquiry-bg-d94d1598d3ca943f2306615b8b9505c2.png";